import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import {
  AddAll,
  Load,
  LoadFail,
  LoadSuccess,
  PlannerIdActionTypes
} from '@core/actions/planner-id.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { PlannerId } from '@app/models/planner-id';

@Injectable()
export class PlannerIdEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(PlannerIdActionTypes.Load),
    switchMap(() => {
      return this.api.getPlannerIds().pipe(
        map((plannerIds: PlannerId[]) => new LoadSuccess(plannerIds)),
        catchError(error => of(new LoadFail(error)))
      );
    })
  );

  @Effect()
  loadSuccess$: Observable<Action> = this.actions$.pipe(
    ofType<LoadSuccess>(PlannerIdActionTypes.LoadSuccess),
    map(action => new AddAll(action.plannerIds))
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
